import React, { useMemo } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import classNames from 'classnames';
import { useTranslation } from '../../../../translations';

const SetsReward = React.forwardRef(({ activeLootBox, prize, rewardType }, ref) => {
  const { t } = useTranslation();
  const currentTitle = prize.gacha_loot_title.replace(/\u2028/g, ' ');
  return (
    <li
      className={classNames('sets__reward', `sets__reward_${activeLootBox?.prizes?.length}`, {
        [`sets__reward_${rewardType}`]: rewardType,
      })}
    >
      <img className={'sets__reward-icon'} src={prize.image} alt={'reward-sets'} />
      <div className={'sets__reward-title'}>{safeHTML(t(currentTitle))}</div>
    </li>
  );
});
export default SetsReward;
SetsReward.displayName = 'SetsReward';
SetsReward.propTypes = {};
